import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@auctisync/ui';
import { Link, Navigate } from 'react-router-dom';
import { SignInForm } from '../../components/SignInForm';
import { useSession } from '../../hooks/useSession';
import { authRedirectUrl } from '../../lib/authRedirect';

/**
 * Unauthenticated landing for `{tenant-domain}/admin` and
 * `app.auctisync.com/admin`. Tenant staff sign-in.
 *
 * If the visitor already has a session, bounce them straight to
 * /admin/dashboard. They can still reach /super/dashboard via direct URL
 * or the super-admin nav if they're a super admin.
 */
export function AdminSignIn() {
  const { session, loading } = useSession();
  if (!loading && session) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
      }}
    >
      <Card style={{ width: '100%', maxWidth: '28rem' }}>
        <CardHeader>
          <CardTitle>Sign in to admin</CardTitle>
          <CardDescription>
            Tenant staff access. Use your AuctiSync account credentials.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <SignInForm magicLinkRedirectTo={authRedirectUrl('/auth/callback')} />
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              fontSize: '0.875rem',
              marginTop: '1rem',
            }}
          >
            <Link to="/admin/forgot-password" style={{ color: 'var(--brand-primary)' }}>
              Forgot password
            </Link>
            <a
              href="https://help.auctisync.com"
              target="_blank"
              rel="noreferrer"
              style={{ color: 'var(--brand-primary)' }}
            >
              Help Center
            </a>
          </div>
        </CardContent>
      </Card>
    </main>
  );
}
